import { FilterGroup } from '../enums';

export const filterGroupHeight: Record<FilterGroup, string> = {
  [FilterGroup.Status]: '180px',
  [FilterGroup.Tags]: '253px',
};

export const dueDateTimeSlots = Array.from({ length: 19 }, (_, i) => i * 30 + 480);
export const availableFromTimeSlots = Array.from({ length: 19 }, (_, i) => i * 30 + 480);
